import React from 'react'
import {
	Email,
	Sms,
	NotificationsOff,
	Group,
	Done,
	Notifications,
	// GroupRemove,
	// GroupAdd,
} from '@material-ui/icons'
import {
	CalendarCheck,
	FileDocument,
	FileDocumentEdit,
	Help,
	TransitConnectionVariant,
	AccountSwitch,
	AccountMultipleMinus,
	AccountMultiplePlus,
	AccountConvert,
	MessageReplyText,
} from 'mdi-material-ui'

export default ({ entityType, entityID, entity, ...props }) => {
	const entityTypes = {
		eventgoaloption: {
			default: <CalendarCheck {...props} />,
			'api.association.associate.contact': <Group {...props} />,
			'api.association.remove.contact': <Group {...props} />,
			'event.signup.submit.contact': <FileDocumentEdit {...props} />,
			'event.email.ses.open': <Email {...props} />,
			'event.email.ses.click': <Email {...props} />,
			'event.email.ses.send': <Email {...props} />,
			'event.sms.twilio.sent': <MessageReplyText {...props} />,
			'event.email.ses.bounce': <Email {...props} />,
			'api.crud.insert.contact': <Group {...props} />,
			'api.unsubscribe.update.contact': <NotificationsOff {...props} />,
			'event.custom.submit.contact':
				entity?.internal_type === 'ci1' ? (
					<TransitConnectionVariant {...props} />
				) : (
					<FileDocument {...props} />
				),
			'api.crud.update.contact': <Group {...props} />,
			'event.sms.twilio.inbound': <Sms {...props} />,
			'event.email.ses.in_ok': <Email {...props} />,
		},
		task: {
			default: <Done {...props} />,
			1: <Email {...props} />,
			2: <Sms {...props} />,
			3: <Notifications {...props} />,
			4: <AccountMultiplePlus {...props} />,
			5: <AccountMultipleMinus {...props} />,
			6: <AccountSwitch {...props} />,
			7: <AccountConvert {...props} />,
		},
	}

	if (entityType) {
		if (entityID) {
			return (
				entityTypes[entityType][entityID] ||
				entityTypes[entityType]['default'] || <Help {...props} />
			)
		}
		if (entityTypes[entityType]) {
			return entityTypes[entityType]['default'] || <Help {...props} />
		}
	}
	return <Help {...props} />
}
